

const shipEquipmentReducer = (state = {}, action) => {
  switch (action.type) {
    case "GetShipEquipmentCountSuccess":
      return Object.assign({}, state, {
        ShipEquipmentCount: action.data,
      });
      break;
    case "GetShipEquipmentCountFailure":
      return Object.assign({}, state, {
        ShipEquipmentCount: action.data,
      });
      break;
    case "getContractPanelDetailSuccess":
      return Object.assign({}, state, {
        ContractPanelDetails: action.data,
      });
      break;
    case "GetShipDetailSuccess":
      return Object.assign({}, state, {
        ShipDetail: action.data,
      });
      break;
    case "getEquipmentComplianceListSuccess":
      return Object.assign({}, state, {
        EquipmentComplianceList: action.data,
      });
      break;
    case "getEquipmentBudgetListSuccess":
      return Object.assign({}, state, {
        EquipmentBudgetList: action.data,
      });
      break;

    case "getEquipmentZoneListSuccess":
      return Object.assign({}, state, {
        EquipmentZoneList: action.data,
      });
      break;
    case "getApproverNameListSuccess":
      return Object.assign({}, state, {
        ApproverList: action.data,
      });
      break;
    case "getCoordinatorNameListSuccess":
      return Object.assign({}, state, {
        CoordinatorList: action.data,
      });
      break;


    case "GetShipDetailFailure":
      return Object.assign({}, state, {
        ShipDetail: action.data,
      });
      break;
    case "GetShipSearchSuccess":
      return Object.assign({}, state, {
        shipSearchResult: action.data,
      });
      break;
    case "GetShipSearchFailure":
      return Object.assign({}, state, {
        shipSearchResult: action.data,
      });
      break;
    case "GetShipEquipmentServiceBudgetSuccess":
      return Object.assign({}, state, {
        shipEquipmentServiceHistoryBudget: action.data,
      });
      break;
    case "GetShipUsersOptionSuccess":
      return Object.assign({}, state, {
        shipUsersReportOptions: action.data,
      });
      break;
    case "GetShipEquipmentServiceBudgetFailure":
      return Object.assign({}, state, {
        shipEquipmentServiceHistoryBudget: action.data,
      });
      break;

    case "GetShipEquipmentBudgetSuccess":
      return Object.assign({}, state, {
        shipEquipmentServiceBudget: action.data,
      });
      break;
    case "GetShipEquipmentBudgetFailure":
      return Object.assign({}, state, {
        shipEquipmentServiceBudget: action.data,
      });
      break;
    case "GetEquipmentInfoSuccess":
      return Object.assign({}, state, {
        EquipmentInfo: action.data,
      });
      break;
    case "GetEquipmentInfoFailure":
      return Object.assign({}, state, {
        EquipmentInfo: action.data,
      });
      break;
    case "GetEquipmentDetailSuccess":
      return Object.assign({}, state, {
        EquipmentDetail: action.data,
      });
      break;
    case "GetEquipmentDetailFailure":
      return Object.assign({}, state, {
        EquipmentDetail: action.data,
      });
      break;
    case "GetEquipmentHistorySuccess":
      return Object.assign({}, state, {
        EquipmentHistory: action.data,
      });
      break;
    case "GetEquipmentHistoryFailure":
      return Object.assign({}, state, {
        EquipmentHistory: action.data,
      });
      break;
    case "getEquipmentServiceUpdateTypeListSuccess":
      return Object.assign({}, state, {
        EquipmentServiceUpdateList: action.data,
      });
      break;
    case "EquipmentDetail":
      return Object.assign({}, state, {
        EquipmentDetail: action.data,
      });
      break;
    case "getEquipmentCyclingServiceYearSuccess":
      return Object.assign({}, state, {
        ShipEquipmentServiceYear: action.data,
      });
      break;
    case "StaffShipId":
      return Object.assign({}, state, {
        StaffShipId: action.data,
      });
      break;
    case "flagandclass":
      return Object.assign({}, state, {
        FlagClass: action.data,
      });
    default: {
      return state;
    }
  }
};
export default shipEquipmentReducer;
